var exports = {
  "kL": "x112a1f60--b7487e--container",
  "u": "x112a1f60--b7487e--crumb",
  "UE": "x112a1f60--b7487e--arrow",
};

module.exports = exports;
